import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { certificationActions } from "../../../actions/certification.action";
import { useEffect, useState } from "react";
import { formatDate, standardList, yearsList } from "../../../utils/utils";
import "./Carbon.css";
import Lottie from "lottie-react";
import pendingAnimation from "./pending.json";
import checkedAnimation from "../../DemandForm/checked.json";
import Button from "../../../components/forms/Buttons/Button";
import Error from "../../../components/Alert/Error";
import {
  fieldRequiredMessage,
  invalidWebsiteURLMessage,
} from "../../../errors/errors";
import Table from "../../../components/Table/Table";
import { validWebsite } from "../../../utils/validation";
import { Tooltip, Typography } from "@material-tailwind/react";
import TextInput from "../../../components/forms/TextInput";
import DownloadFile from "../../../components/certification-process/DownloadFile";
import RetirementRow from "./RetirementRow";
import { certificationService } from "../../../services/certification.service";
import loading from "./upload-files-loader.json";
import CertificationFormModal from "../../../components/Modals/CertificationFormModal";

export default function CarbonRetirements({
  transactionId,
  certificationId,
  certificationCode,
}) {
  const user = JSON.parse(localStorage.getItem("user"));
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const certificationSteps = useSelector(
    (state) => state.certificationStep.arrayCertification
  );

  const addCreditRetirement = useSelector(
    (state) => state.addCreditRetirements.data
  );

  const getLastSequence = (str) => {
    const segments = str?.split("-");
    const lastSequence = segments?.pop();

    return lastSequence;
  };

  const certifications = useSelector(
    (state) => state.certification.arrayCertification
  );

  const ccrData = useSelector((state) => state.certificationStep.ccr);
  const [currentStep, setCurrentStep] = useState();
  const [errorCount, setErrorCount] = useState(0);
  const [currentCertification, setCurrentCertification] = useState(0);
  const [transactionToBeRetired, setTransactionToBeRetired] = useState();
  const [proofFiles, setProofFiles] = useState([]);
  const [isLineSaved, setIsLineSaved] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [currentLine, setCurrentLine] = useState();
  const [formData, setFormData] = useState(ccrData || []);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ccrRefusedByCoc, setCcrRefusedByCoc] = useState(false);
  const [showErrorToBeRetired, setShowError] = useState(false);
  const [showErrorValueRetired, setShowErrorValueRetired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  let ccrDataUpdated = useSelector(
    (state) => state.updateCreditRetirements.data
  );
  const validationCCRStep = useSelector(
    (state) => state.validationCCRStep.data
  );
  const rejectRetirementStep = useSelector(
    (state) => state.rejectRetirementStep.data
  );
  const certificationAllData = useSelector(
    (state) => state.certificationStep.allData
  );
  const dispatch = useDispatch();
  const conditionUpdate =
    user?.data.userRole === "VAP" ||
    currentStep?.isValidated ||
    currentStep?.isSentToCoc;

  useEffect(() => {
    if (user?.data.userRole === "VAP") {
      dispatch(certificationActions.getCertificationList());
    } else {
      dispatch(certificationActions.getCertificationByUserId(user?.data.id));
    }
    if (certificationSteps.length > 0 && ccrData?.length === 0) {
      console.log(`certificationSteps: ${JSON.stringify(certificationSteps)}`);
      const ccrStep = certificationSteps.filter(
        (certif) =>
          certif.processStep === 2 && certif.certificationId === certificationId
      );
      console.log(`ccrStep: ${JSON.stringify(ccrStep)}`);
      if (ccrStep.length > 0) {
        setCurrentStep(ccrStep[0]);
        dispatch(
          certificationActions.getCarbonCreditRetirementById(ccrStep[0].id)
        );
      }
    }

    if (
      ccrData?.length > 0 &&
      ccrData[0]?.certificationId === certificationId
    ) {
      setIsLoading(false);
      console.log(`ccrData: ${JSON.stringify(ccrData)}`);
      console.log(`ccrData length: ${JSON.stringify(ccrData?.length)}`);
      const rows = [];
      const ccrRefused = ccrData?.filter(
        (ccr) => ccr.currentCertificationStatusName === "RefusedByCoc"
      );
      if (ccrRefused.length > 0) {
        console.log(`refused`);
        setCcrRefusedByCoc(true);
      }
      ccrData?.forEach((data) => {
        const retirementRow = (
          <RetirementRow
            ccrData={data}
            conditionUpdate={conditionUpdate}
            setCurrentLine={setCurrentLine}
            currentLine={currentLine}
            currentStep={currentStep}
            user={user}
            setRowsData={setRowsData}
            rowsData={rowsData}
            setFormData={setFormData}
            formData={formData}
            ccrRefused={ccrRefused.length > 0 ? true : false}
            certificationId={certificationId}
            transactionId={transactionId}
            transactionToBeRetired={
              transactionToBeRetired || ccrData[0].transactionToBeRetired
            }
            transactionCarbonFootPrint={
              ccrData.length > 0 && ccrData[0].transactionCarbonFootPrint
            }
            setIsLineSaved={setIsLineSaved}
          />
        );
        rows.push(retirementRow);
      });
      setRowsData(rows);
      setCurrentStep(ccrData[0]);
    }
  }, [
    certificationSteps,
    dispatch,
    ccrData,
    setValue,
    certificationId,
    transactionId,
    user?.data.id,
    user?.data.userRole,
  ]);

  useEffect(() => {
    console.log(`currentLine: ${JSON.stringify(currentLine)}`);
    console.log(`formData: ${JSON.stringify(formData)}`);
  }, [currentLine, formData]);
  useEffect(() => {
    if (
      ccrDataUpdated?.id &&
      ccrDataUpdated.certificationId === certificationId
    ) {
      const data = ccrDataUpdated;
      setValue("transactionId", transactionId);
      setValue("transactionCarbonFootPrint", data.transactionCarbonFootPrint);
      setValue("transactionToBeRetired", data.transactionToBeRetired);
      setValue("standard", data.standard);
      setValue("quantity", data.quantity);
      setValue("idRetirement", data.idRetirement);
      setValue("serialNumbers", data.serialNumbers);
      setValue(
        "projectDescriptionAndLocation",
        data.projectDescriptionAndLocation
      );
      setValue("retirementDate", formatDate(data.retirementDate));
      setValue("proofOfRetirement", data.proofOfRetirement);
      setValue("certificationId", certificationId);
      setValue("vintageYear", new Date(data.vintageYear).getFullYear());
      setProofFiles(data.attachments);
    }

    if (certifications) {
      if (user?.data.userRole === "VAP") {
        const VAPcertifications = certifications.filter(
          (certif) => certif.vvbUserId === user?.data.id
        );
        setCurrentCertification(VAPcertifications);
      }
      const certification = certifications.filter(
        (data) =>
          getLastSequence(data.certificationCode) ===
          getLastSequence(certificationCode)
      );
      setCurrentCertification(certification[0]);
    }
  }, [
    certificationId,
    transactionId,
    setValue,
    ccrDataUpdated,
    certifications,
    user?.data.id,
    user?.data.userRole,
    certificationCode,
  ]);

  useEffect(() => {
    if (
      validationCCRStep ||
      ccrDataUpdated ||
      rejectRetirementStep ||
      addCreditRetirement
    ) {
      setIsLoading(false);
      dispatch(certificationActions.getCertificationStepByCID(certificationId));
    }
  }, [
    validationCCRStep,
    certificationId,
    dispatch,
    ccrDataUpdated,
    rejectRetirementStep,
    addCreditRetirement,
  ]);

  const validateCarbonToBeRetired = (value) => {
    console.log(`carbon footprnt: ${currentCertification?.carbonFootPrint}`);
    if (parseInt(value) < parseInt(currentCertification?.carbonFootPrint)) {
      setShowErrorValueRetired(true);
      return false;
    }
    return true;
  };
  const changeInputValue = (e) => {
    //setErrorCount(errorCount + 1);
    //setShowErrorValueRetired(false);
    console.log(`value ${e.target.value}`);
    const isValidated = validateCarbonToBeRetired(e.target.value);
    if (isValidated) {
      console.log(`isValidate ${isValidated}`);
      setValue("transactionToBeRetired", e.target.value);
      setTransactionToBeRetired(e.target.value);
      setShowErrorValueRetired(false);
    } else {
      console.log(`isValidate ${isValidated}`);
      setShowErrorValueRetired(true);
    }
  };

  const onSubmit = async (byCOC = false) => {
    setIsLoading(true);
    console.log(`formdata on submit: ${JSON.stringify(formData)}`);
    if (ccrRefusedByCoc) {
      const updatedFormData = formData.map((form) => {
        return { ...form, isSentToCoc: true };
      });
      if (byCOC === true) {
        const response =
          await certificationService.updateCarbonCreditRetirement(
            updatedFormData,
            certificationId
          );
        if (response.data) {
          if (response.data?.length > 0) {
            for (const ccr of response.data) {
              dispatch(
                certificationActions.validateCCRStep({
                  stepId: ccr.id,
                  certificationId: certificationId,
                })
              );
            }
          }
        }
      } else {
        dispatch(
          certificationActions.updateCarbonCreditRetirement(
            updatedFormData,
            certificationId
          )
        );
      }
    } else {
      if (transactionToBeRetired) {
        const retirementData = new FormData();
        formData.forEach((form, index) => {
          if (form !== null) {
            console.log(`form on submit: ${JSON.stringify(form)}`);

            retirementData.append(
              `retirements[${index}].CertificationId`,
              certificationId
            );
            retirementData.append(
              `retirements[${index}].ProofOfRetirement`,
              form.proofOfRetirement
            );
            retirementData.append(
              `retirements[${index}].RetirementDate`,
              new Date(form.retirementDate).toISOString()
            );
            retirementData.append(
              `retirements[${index}].ProjectDescriptionAndLocation`,
              form.projectDescriptionAndLocation
            );
            console.log(`currentStep: ${JSON.stringify(currentStep)}`);
            retirementData.append(`retirements[${index}].CurrentStatus`, 3);
            retirementData.append(`retirements[${index}].ProcessStep`, 3);
            retirementData.append(
              `retirements[${index}].IdRetirement`,
              form.idRetirement
            );
            retirementData.append(
              `retirements[${index}].Quantity`,
              parseInt(form.quantity)
            );
            retirementData.append(
              `retirements[${index}].SerialNumbers`,
              form.serialNumbers
            );
            retirementData.append(
              `retirements[${index}].VintageYear`,
              new Date(form.vintageYear).toISOString()
            );
            retirementData.append(
              `retirements[${index}].Standard`,
              form.standard
            );
            retirementData.append(`retirements[${index}].IsSentToCoc`, true);
            retirementData.append(`retirements[${index}].IsValidated`, false);
            retirementData.append(
              `retirements[${index}].TransactionToBeRetired`,
              transactionToBeRetired
            );
            retirementData.append(
              `retirements[${index}].TransactionCarbonFootPrint`,
              currentCertification?.carbonFootPrint
            );
            if (form.files) {
              retirementData.append(`retirements[${index}].Files`, form.files);
            }
          }
        });
        for (let pair of retirementData.entries()) {
          console.log(pair[0], pair[1]);
        }
        if (byCOC === true) {
          const response = await certificationService.addCarbonCreditRetirement(
            retirementData
          );

          if (response) {
            if (response?.length > 0) {
              for (const ccr of response) {
                dispatch(
                  certificationActions.validateCCRStep({
                    stepId: ccr.id,
                    certificationId: certificationId,
                  })
                );
              }
            }
          }
        } else {
          dispatch(
            certificationActions.createCarbonCreditRetirement(retirementData)
          );
        }
      } else {
        setIsLoading(false);
        setShowError(true);
      }
    }
  };

  const handleConfirmationResponse = (keepChanges) => {
    if (!keepChanges) {
      onSubmit();
    }
    setShowModal(false);
  };

  const onHandleSubmit = () => {
    setShowModal(true);
  };

  const handleValidateStep = () => {
    setErrorCount(errorCount + 1);
    if (ccrData?.length > 0) {
      if (ccrRefusedByCoc && !ccrData[0].isSentToCoc) {
        onSubmit(true);
      } else {
        setIsLoading(true);
        for (const ccr of ccrData) {
          dispatch(
            certificationActions.validateCCRStep({
              stepId: ccr.id,
              certificationId: certificationId,
            })
          );
        }
      }
    } else {
      onSubmit(true);
    }
  };

  const handleRejectStep = () => {
    setIsLoading(true);
    for (const ccr of ccrData) {
      dispatch(
        certificationActions.rejectRetirementStep({
          stepId: ccr.id,
          certificationId,
        })
      );
    }
    // dispatch(
    //   certificationActions.rejectRetirementStep({
    //     stepId: ccrData[0]?.id,
    //     certificationId,
    //   })
    // );
  };

  const handleAddLine = () => {
    setCurrentIndex(currentIndex + 1);
    const lineCreditRetirement = (
      <RetirementRow
        conditionUpdate={conditionUpdate}
        setCurrentLine={setCurrentLine}
        currentLine={currentLine}
        currentStep={currentStep}
        user={user}
        setRowsData={setRowsData}
        rowsData={rowsData}
        setFormData={setFormData}
        formData={formData}
        ccrRefused={ccrRefusedByCoc}
        certificationId={certificationId}
        transactionId={transactionId}
        transactionToBeRetired={
          transactionToBeRetired ||
          (ccrData?.length > 0 && ccrData[0].transactionToBeRetired)
        }
        transactionCarbonFootPrint={
          ccrData?.length > 0 && ccrData[0].transactionCarbonFootPrint
        }
        codeCertification={ccrData?.length > 0 && ccrData[0].codeCertification}
        setIsLineSaved={setIsLineSaved}
      />
    );
    setRowsData([...rowsData, lineCreditRetirement]);
  };

  console.log(`carbonFootPrint: ${JSON.stringify(currentCertification)}`);

  return (
    <div className="shadow-lg rounded-2xl py-4 mt-4">
      {isLoading && (
        <div className="upload-overlay">
          <Lottie
            animationData={loading}
            style={{ width: "250px", height: "250px" }}
          />
        </div>
      )}
      <h1 className="uppercase font-semibold text-lg text-center">
        Carbon credits retirement
      </h1>
      <div className="flex w-full justify-between items-center">
        <p className="w-1/2 flex flex-col col">
          <span className="capitalize">
            Transaction carbon footprint :{" "}
            {currentCertification?.carbonFootPrint
              ? currentCertification?.carbonFootPrint
              : certificationAllData?.carbonCo2Value
              ? certificationAllData?.carbonCo2Value
              : certificationAllData?.totalCO2Footprint}{" "}
            tCO2
          </span>
        </p>
        <div className="w-1/2 flex flex-col col">
          <span className="capitalize">Retired Carbon Credits :</span>{" "}
          <div className="">
            <>
              <TextInput
                isNumberType={true}
                placeholder="Transaction"
                className="pl-0 w-full bg-white mb-2 border-x-0 border-t-0 border-b-2 focus:outline-none focus:ring-0"
                type="text"
                name="transactionToBeRetired"
                // register={{
                //   ...register("transactionToBeRetired", { required: true }),
                // }}
                disabled={conditionUpdate}
                onChange={changeInputValue}
                value={
                  (ccrDataUpdated?.certificationId === certificationId ||
                    (ccrData?.length > 0 &&
                      ccrData[0]?.certificationId === certificationId)) &&
                  (ccrDataUpdated?.transactionToBeRetired ||
                    (ccrData?.length > 0 && ccrData[0]?.transactionToBeRetired))
                }
              />
              {(errors.transactionToBeRetired &&
                errors.transactionToBeRetired.type === "required") ||
                (showErrorToBeRetired && (
                  <Error
                    key={errorCount}
                    text={fieldRequiredMessage("Transaction to be retired")}
                  />
                ))}
              {showErrorValueRetired && (
                <Error
                  key={errorCount}
                  text={`Transaction to be retired must be more than transaction carbon footprint value`}
                />
              )}
            </>
          </div>
        </div>

        <div className="w-1/2 flex flex-col col">
          <div
            className="flex flex-col items-center justify-center"
            hidden={!currentStep?.isValidated || currentStep?.processStep !== 3}
          >
            <Lottie
              loop={2}
              style={{ width: "150px", height: "150px" }}
              animationData={checkedAnimation}
            />
          </div>

          <div
            className="flex flex-col items-center justify-center"
            hidden={
              !(
                (currentStep?.isSentToCoc &&
                  !currentStep?.isValidated &&
                  user?.data?.userRole !== "COC") ||
                (user?.data.userRole === "COC" &&
                  user?.data.userRole === "VAP" &&
                  !currentStep?.isSentToCoc &&
                  !currentStep?.isValidated)
              )
            }
          >
            <div className="py-4">
              <img
                width={`150px`}
                height={`150px`}
                src="/assets/images/clock-pending-time.svg"
                alt="pending"
              />
            </div>
            <p className="text-[#aaa]">
              Proof of offsetting has been communicated to COC for certification
              issuance
            </p>
          </div>
        </div>
      </div>

      <div className="mt-11 table-wrapper relative overfow-x-auto h-auto max-h-[648px] shadow-sm mb-4 overflow-y-auto rounded-lg carbon mx-4">
        <table className="w-full px-2">
          <thead className="bg-coc-blue">
            <tr className="h-12">
              <th className="text-white font-light pl-2 head resizable">
                Standard
              </th>
              <th className="text-white font-light pl-2 head resizable">
                Vintage year
              </th>
              <th className="text-white font-light pl-2 head w-2 resizable">
                Quantity
              </th>
              <th className="text-white font-light pl-2 head w-2 resizable">
                Project ID
              </th>
              <th className="text-white font-light pl-2 head resizable">
                Serial number
              </th>
              <th
                title="Project description"
                className="text-white font-light pl-2 head resizable truncate ..."
              >
                Project description and location
              </th>
              <th className="text-white font-light pl-2 head resizable">
                Retirement date
              </th>
              <th
                title="Proof of retirement"
                className="text-white font-light p-2 resizable truncate ..."
              >
                Proof of retirement
              </th>

              <th className="w-[10px]"></th>
              {(user?.data.userRole === "Client" ||
                user?.data.userRole === "COC") &&
                !currentStep?.isSentToCoc && (
                  <th>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={handleAddLine}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="addline w-5 h-5 mx-auto text-right text-coc-green hover:cursor-pointer"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-11.25a.75.75 0 00-1.5 0v2.5h-2.5a.75.75 0 000 1.5h2.5v2.5a.75.75 0 001.5 0v-2.5h2.5a.75.75 0 000-1.5h-2.5v-2.5z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </th>
                )}
            </tr>
          </thead>

          <tbody id="tableBody">{rowsData}</tbody>
        </table>

        {/* <Table columns={columns} data={data} /> */}
        <div className="flex items-center justify-center mb-9 py-4 ml-2">
          {user?.data.userRole !== "COC" && user?.data.userRole !== "VAP" && (
            <Button
              //className={`bg-coc-green text-white px-12 py-2 rounded-lg`}
              type="button"
              onClick={onHandleSubmit}
              disabled={
                isLineSaved === false ||
                (currentStep?.processStep === 3 && currentStep?.isSentToCoc) ||
                (ccrData?.length > 0 && ccrData[0]?.isSentToCoc)
              }
              text={`Send to COC for Validation`}
              backgroundColor={`coc-green`}
              hoverBgColor={`bg-[#329940]`}
            />
          )}
        </div>
      </div>
      {user?.data.userRole === "COC" && (
        <div className={`flex justify-center`}>
          <div className="w-1/4 flex justify-between">
            <div className="mr-3">
              <Button
                disabled={
                  currentStep?.isValidated ||
                  !currentStep?.isSentToCoc ||
                  (ccrData.length > 0 && !ccrData[0].isSentToCoc)
                }
                className={`px-12 py-3 bg-coc-blue text-white capitalize flex text-xs items-center hover:bg-coc-blue-600 rounded-lg`}
                onClick={handleRejectStep}
                backgroundColor={`coc-blue`}
                hoverBgColor={`bg-coc-blue-600`}
                text={`reject`}
              />
            </div>
            <Button
              disabled={currentStep?.isValidated}
              //className={`px-12 py-3 bg-coc-green text-white capitalize flex text-xs items-center hover:bg-[#329940] rounded-lg`}
              onClick={handleValidateStep}
              backgroundColor={`coc-green`}
              hoverBgColor={`bg-[#329940]`}
              text={`validate`}
            />
          </div>
        </div>
      )}
      <CertificationFormModal
        showConfirmationModal={showModal}
        handleConfirmationResponse={handleConfirmationResponse}
        text={`Are you sure you have recorded all lines of evidence for the carbon removal?`}
      />
    </div>
  );
}
